// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Warning = function Warning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.703 3.293A.34.34 0 0 1 10 3.125c.121 0 .234.063.297.168l7.746 12.723a.567.567 0 0 1-.484.86H2.44a.567.567 0 0 1-.484-.86zm-1.601-.977L.355 15.04a2.442 2.442 0 0 0 2.086 3.71H17.56a2.442 2.442 0 0 0 2.085-3.71L11.899 2.316a2.224 2.224 0 0 0-3.796 0m3.148 12.059a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-.312-7.187A.935.935 0 0 0 10 6.25a.935.935 0 0 0-.937.938v3.75c0 .519.417.937.937.937s.938-.418.938-.937z"
  }));
};
